import { BackgroundInterface } from 'common/types/background-interfaces'
import { getMobileBackgroundFileId } from 'common/utils/getMobileBackgroundFileId'
import { useFiles } from 'publisher/store'
import { getFile } from 'publisher/store/file/fileSelectors'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

interface UseBackgroundImageInterface {
  backgroundFileId: BackgroundInterface['backgroundFileId']
  mobileBackgroundFileId: BackgroundInterface['backgroundFileId']
}

export const useBackgroundImage = ({
  backgroundFileId,
  mobileBackgroundFileId,
}: UseBackgroundImageInterface) => {
  const backgroundFile = useFiles(state => getFile(state, backgroundFileId))

  const mobileBackgroundFile = useFiles(state =>
    getFile(
      state,
      getMobileBackgroundFileId(backgroundFileId, mobileBackgroundFileId),
    ),
  )

  const backgroundImage = getBackgroundImageStyleValue(backgroundFile)

  const mobileBackgroundImage =
    getBackgroundImageStyleValue(mobileBackgroundFile)

  return { backgroundImage, mobileBackgroundImage }
}
